import "./Products.css";
import "./ProductsResponsive.css";

import productList from "../../../assets/data/products/product-list.json";
import ProductItem from "./product-item/ProductItem";
import CustomAnchor from "../../../shared/Anchor/CustomAnchor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

function Products() {
  return (
    <div className="products-container">
      <div className="products-header d-block">
        <h1 className="text-center">Our Fresh Produce</h1>
        <p className="text-center text-light">
          Discover fresh, flavorful, and ready-to-enjoy vegetables—delivered
          with care to make healthy living simple and convenient.
        </p>
      </div>
      <div className="products-list row m-0">
        {productList?.map((item, index) => (
          <ProductItem item={item} key={index} />
        ))}
      </div>
      <div className="products-footer">
        <CustomAnchor
          path="/shop"
          classname="btn btn-dark btn-md products-footer-shop-more"
        >
          <span>Shop More</span>
          <FontAwesomeIcon
            icon={faArrowUpRightFromSquare}
            className="header-anchor-icon"
          />
        </CustomAnchor>
      </div>
    </div>
  );
}

export default Products;
